import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined';

const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  marginLeft: '15%',
  [theme.breakpoints.down('sm')]: {
    marginLeft: '5%',
  },
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontFamily: "DiodrumSemibold",
  textAlign: "left",
  fontSize: "14px",
  flexGrow: 1,
  [theme.breakpoints.down('sm')]: {
    fontSize: "12px",
  },
}));

const StyledIconButton = styled(IconButton)(({theme})=>({
  padding: '0px',
  [theme.breakpoints.between('xs', 'md')]: {
    paddingLeft: '10px',
  },
}));

const StyledRemoveIcon = styled(RemoveCircleOutlineOutlinedIcon)(({ theme }) => ({
  fontSize: "2.5rem",
  [theme.breakpoints.down('sm')]: {
    fontSize: "2rem",
  },
}));

const StyledAddIcon = styled(ControlPointOutlinedIcon)(({ theme }) => ({
  fontSize: "2.5rem",
  [theme.breakpoints.down('sm')]: {
    fontSize: "2rem",
  },
}));

const StyleGrid = styled(Grid)(({ theme }) => ({
  width: "100%",
  maxWidth: "150px",
  display: "flex",
  [theme.breakpoints.between('xs', 'md')]: {
    maxWidth: "100px",
    marginLeft: "10px",
  },

}));

const ColumnHeader = ({ headerText, onRemove, onShow, isLastVisible, nextColumnId, visibleColumnCount }) => (
  <StyledBox>
    <Grid container alignItems="left" sx={{maxWidth:'150px',width:'100%'}} >
      <Grid item xs={12}  alignItems="left" sx={{display:'flex'}}>
        <StyledTypography>
          {headerText}
        </StyledTypography>
        {visibleColumnCount > 2 && nextColumnId !== 'input_1' && (
          <StyledIconButton onClick={onRemove}>
            <StyledRemoveIcon />
          </StyledIconButton>
        )}
      </Grid>
    </Grid>
      <StyleGrid item xs={1} container >
        {isLastVisible && visibleColumnCount !== 5 && (
          <StyledIconButton onClick={() => onShow(nextColumnId)}>
            <StyledAddIcon />
          </StyledIconButton>
        )}
      </StyleGrid>
  </StyledBox>
);

export default ColumnHeader;